import { render, staticRenderFns } from "./WuzidiaopeiByIdForm.vue?vue&type=template&id=d8452802&scoped=true&"
import script from "./WuzidiaopeiByIdForm.vue?vue&type=script&lang=js&"
export * from "./WuzidiaopeiByIdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8452802",
  null
  
)

export default component.exports